import moment from "moment";
class accountBalanceHistory {
    constructor(
        id,
        date,
        empId,
        conceptId,
        nameConcept,
        amount,
        balance,
        operId,
        nameOper
        
    ) {
        this.id = id;
        this.date = moment(date).utc().format("DD-MM-YYYY") ;
        this.empId = empId;
        this.conceptId = conceptId,
        this.nameConcept = nameConcept,
        this.amount = amount,
        this.balance = balance,
        this.operId = operId,
        this.nameOper = nameOper
    }
    static fromJson({
            movimId,
            fecha,
            empId,
            conceptoId,
            nomConcepto,
            cantidad,
            saldo,
            operId,
            nomOper
    }) {
        return new accountBalanceHistory(
            movimId,
            fecha,
            empId,
            conceptoId,
            nomConcepto,
            cantidad,
            saldo,
            operId,
            nomOper
        );
    }
}
export default accountBalanceHistory;
